module.exports = __webpack_public_path__ + "img/39a7b75a3df263377f391fe65bae61af.png";